import {SetStateAction, useEffect, useState} from "react";
import {UserService} from "./Service";
import {toast} from "react-hot-toast";
import {UploadService} from "../../utils/UploadService";
import Select from 'react-select';
import {useParams} from "react-router-dom";


const EditUser = () => {
    const {id}: any = useParams();
    const [service] = useState(new UserService());
    const [uploadService] = useState(new UploadService());
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [profilePic, setProfilePic] = useState('');
    const [role, setRole] = useState<{ label: string, value: string }|null>(null);
    const [roleOptions, setRoleOptions] = useState([]);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const res = service.updateUser({
            id,
            name: name,
            email: email,
            ...(phoneNumber && {phoneNumber: phoneNumber}),
            ...(password && {password: password}),
            ...(profilePic && {profilePic: profilePic}),
            ...(role && {role: role.value}),
        });

        res.then((res) => {
            if (res) {
                toast.success('User update successfully');
            }
        });

    }

    const getUser = async () => {
        const user = await service.getUser(id);
        setName(user.name);
        setEmail(user.email);
        setPhoneNumber(user.phoneNumber);
        setProfilePic(user.profilePic);
        setRole({
            label: user.role.name,
            value: user.role.id
        });
    }

    const handleImageChange = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            uploadService.upload(file).then((res) => {
                console.log(res);
                if (res.length > 0) {
                    setProfilePic(res[0]);
                    toast.success('Logo uploaded successfully');
                }
            });
        }
    };

    const getRoleOptions = async () => {
        const roles = await service.allRoles();
        const options = roles.map((role: any) => {
            return {
                label: role.name,
                value: role.id
            }
        });
        setRoleOptions(options);
    }

    useEffect(() => {
        getRoleOptions();
        getUser();
    }, []);

    return (
        <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Add User</h5>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit} className="row">
                        <div className="col-lg-12">
                            <div className="form-title">
                                <h5>General Information</h5>
                            </div>
                        </div>
                        <div className="profile-picture">
                            <div className="upload-profile me-2">
                                <div className="profile-img">
                                    <img
                                        id="blah"
                                        className="avatar"
                                        src={profilePic !== '' ? profilePic : `https://ui-avatars.com/api/?background=4F6F52&color=fff&name=${name.length > 0 ? name : 'Company Name'}&size=40&rounded=true`}
                                        alt="profile-img"
                                    />
                                </div>
                            </div>
                            <div className="img-upload">
                                <label className="btn btn-primary">
                                    Upload new profile picture <input type="file"
                                                                      onChange={handleImageChange}/>
                                </label>
                                <p className="mt-1">
                                    Image Should be minimum 152 * 152 Supported File format JPG,PNG.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                                <label>Name <span className="text-danger">(required)</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter user name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                                <label>Email <span className="text-danger">(required)</span></label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter user email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                                <label>Phone Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter user phone number"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                                <label>Password</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter user password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="mb-3 col-12">
                            <label htmlFor="type" className="form-label">Role <span
                                className="text-danger">(required)</span></label>
                            <Select
                                name="permission"
                                options={roleOptions}
                                value={role}
                                onChange={(e) => {
                                    // @ts-ignore
                                    setRole(e);
                                }} required={true}/>
                        </div>
                        <div className="col-lg-12">
                            <div className="btn-path text-end">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-cancel bg-primary-light me-3"
                                    onClick={() => {
                                        setName('');
                                        setEmail('');
                                        setPhoneNumber('');
                                        setPassword('');
                                        setProfilePic('');
                                        setRole(null);
                                    }}
                                >
                                    Cancel
                                </a>
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default EditUser;
